/**
 * Gating widoczności integracji Shopify (VP-223).
 *
 * Integracja jest wdrażana na produkcję z ograniczoną widocznością: widzą i
 * testują ją wyłącznie wyznaczeni testerzy, dla reszty userów jest ukryta.
 * Dostęp NIE jest nadawany przez zmianę roli w DB (CLAUDE.md §0 — zakaz
 * nadawania `super_admin`), tylko przez tę email whitelistę.
 *
 * Jedno źródło prawdy współdzielone między backendem (middleware
 * `requireShopifyAccess`) a frontendem (integrations-hub, settings), żeby lista
 * nie rozjechała się między plikami — wzorzec z `module-access.ts`.
 */

/**
 * Emaile testerów dopuszczonych do integracji Shopify (poza rolą super_admin).
 * meta-reviewer@ to konto demo podawane recenzentom App Store (Shopify/Meta) —
 * bez niego recenzent Shopify nie widzi integracji, którą właśnie zainstalował,
 * i recenzja pada (VP-255).
 */
export const SHOPIFY_TESTER_EMAILS: ReadonlySet<string> = new Set<string>([
  "adrian.gasek.99@gmail.com",
  "meta-reviewer@gawronify.com",
]);

export type ShopifyAccessUser = {
  role?: string | null;
  email?: string | null;
};

/**
 * Dostęp do integracji Shopify: rola `super_admin` LUB email na whiteliście
 * testerów. Porównanie email case-insensitive.
 */
export function canAccessShopifyIntegration(user: ShopifyAccessUser | null | undefined): boolean {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const email = (user.email ?? "").toLowerCase();
  return email.length > 0 && SHOPIFY_TESTER_EMAILS.has(email);
}
